import {AccessToken,AcessTokenActionTypes, ACCESS_TOKEN_DECODED} from './actionTypes';

export function accessTokenDecoded(payload: AccessToken): AcessTokenActionTypes{
  return {
    type: ACCESS_TOKEN_DECODED, 
    payload,
  }
}